import { render, staticRenderFns } from "./ModelEditView.vue?vue&type=template&id=3d1c8b50&"
import script from "./ModelEditView.vue?vue&type=script&lang=js&"
export * from "./ModelEditView.vue?vue&type=script&lang=js&"
import style0 from "./ModelEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports